// extracted by mini-css-extract-plugin
export default {"wrapper":"Dropdown_wrapper_GhLjD","trigger":"Dropdown_trigger_iY65V","canvas":"Dropdown_canvas_H5lwI","dropdown":"Dropdown_dropdown_PaOA4"};